
export default class AbbraviatedTextComponent {
	constructor() {
		this.template = require('./abbraviated.text.view.html');
		this.controller = AbbraviatedTextController;
		this.bindings = {
			text: '<'
		};
	}
}

AbbraviatedTextComponent.META = {
	name: 'abbraviatedText'
};

class AbbraviatedTextController {
    /* ngInject */
	constructor($element, JFrogEventBus, JfFullTextService, $sanitize) {
		this.$element = $element;
		this.$sanitize = $sanitize;
		this.jFrogEventBus = JFrogEventBus;
		this.fullTextService = JfFullTextService;
	}
	$onInit() {
	    this.text = this.$sanitize(this.text);
    }

	showTooltip() {
		return this.isTextOverflowing();
	}

	isTextOverflowing() {
		return this.text && this.$element.find('p').attr('data-overflowed') === 'true';
	}

	onTextClick() {
		if (this.isTextOverflowing()) {
			this.fullTextService.showFullTextModal(this.text,'Description');
		}
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-abbraviated-text/abbraviated.text.component.js